import config from "../config.json";

declare global {
  interface Window {
    grecaptcha: any;
  }
}

type Action =
  "comprovantes" |
  "comprovantes_detalhe" |
  "contracheque" |
  "contracheque_detalhe" |
  "dados_pessoais" |
  "documentos" |
  "emprestimos" |
  "emprestimo_detalhe" |
  "emprestimo_simulador" |
  "emprestimo_simulador_contratacao" |
  "emprestimo_simulador_prestacoes" |
  "emprestimo_simulador_resumo" |
  "formularios" |
  "home_assistido" |
  "home_ativo" |
  "informe_rendimentos" |
  "listar_participantes" |
  "login" |
  "esqueci_senha" |
  "selecionar_matricula" |
  "termos" |
  "primeiro_acesso" |
  "planos" |
  "plano_saude" |
  "recadastramento" |
  "relacionamento" |
  "selecionar_participantes" |
  "simulador_renda_mensal" |
  "simulador_renda_mensal_resultado" |
  "trocar_senha";

export default class reCAPTCHA {
  siteKey: string;
  action: Action;

  constructor(action: Action) {
    if (config.reCAPTCHA_site_key_v3) {
      loadReCaptcha(config.reCAPTCHA_site_key_v3);
      this.siteKey = config.reCAPTCHA_site_key_v3;
      this.action = action;
    }
  }

  async getToken(): Promise<string> {
    let token = "";
    if (this.siteKey) {
      await window.grecaptcha.execute(this.siteKey, { action: this.action })
        .then((res: string) => {
          token = res;
        })
    }
    return token;
  }
}

const loadReCaptcha = (siteKey: string) => {
  if (siteKey) {
    const script = document.createElement('script')
    script.src = `https://www.recaptcha.net/recaptcha/api.js?render=${siteKey}`
    document.body.appendChild(script)
  }
}